import { useEffect, useMemo, useState } from "react";
import MyTable from "../ui/Table";
import { Button, Input, Space } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import apiRoutes from "../api/apiRoutes";
import { apiGet, apiPost } from "../api/request";
import AddReaderModal from "../modals/AddReaderModal";
import AddAdminModal from "../modals/AddAdminModal";
import GlowButton from "../components/GlowButton";

const AdminUsers = () => {
  const navigate = useNavigate();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    mobile: "",
    role: "",
    password: "",
  });

  const [searchText, setSearchText] = useState("");
  const [admin, setAdmin] = useState([]);
  // Show/hide modal

  const showModal = () => setIsModalVisible(true);

  const hideModal = () => {
    setFormData({
      firstname: "",
      lastname: "",
      email: "",
      mobile: "",
      role: "",
      password: "",
    });
    setIsModalVisible(false);
  };

  useEffect(() => {
    fetchAdmin();
  }, []);

  const fetchAdmin = async () => {
    try {
      const res = await apiGet(apiRoutes.getAllAdmins);
      if (Array.isArray(res.admins)) {
        setAdmin(res.admins);
      }
    } catch (err) {
      console.error("Failed to fetch Readers:", err);
    }
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        first_name: formData.firstname,
        last_name: formData.lastname,
        email: formData.email,
        mobile: formData.mobile,
        role: "admin",
        password: formData.password,
      };
      console.log("admin data:", payload);
      const res = await apiPost(apiRoutes.createAdmin, payload);

      hideModal();
      fetchAdmin();
    } catch (err) {
      console.error("Failed to create quote:", err);
    }
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const filteredData = useMemo(() => {
    return admin
      .filter((item) => item && typeof item === "object") // <- important check
      .filter((item) =>
        Object.values(item).some((val) =>
          String(val).toLowerCase().includes(searchText.toLowerCase()),
        ),
      );
  }, [searchText, admin]);

  const columns = [
    {
      title: "Name",
      dataIndex: "first_name",
      key: "first_name",
      render: (text) => (text?.trim() ? text : "Unknown"),
    },
    {
      title: "Phone",
      dataIndex: "mobile",
      key: "mobile",
      render: (text) => (text ? text : "-"),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text) => (text ? text : "-"),
    },

    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      render: (text) => (text ? text : "-"),
    },
  ];

  return (
    <div>
      <h1 className="text-xl font-semibold mb-4">Admin List</h1>

      <div className="border border-gray-300 rounded-md">
        {/* Changed this div to use flex and justify-between */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4 p-4">
          {/* Input remains on the left */}
          <Space className="mb-2 md:mb-0">
            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={handleSearch}
              className="w-[250px]"
            />
          </Space>

          <GlowButton
            type="primary"
            icon={<PlusOutlined />}
            onClick={showModal}
            style={{ backgroundColor: "black", borderColor: "black" }}
          >
            + Create Admin
          </GlowButton>
        </div>
        <div className="border border-gray-200 rounded-md">
          <MyTable
            columns={columns}
            dataSource={filteredData}
            // dataSource={[...filteredData].reverse()}
          />
        </div>
      </div>

      <AddAdminModal
        visible={isModalVisible}
        onCancel={hideModal}
        onSubmit={handleSubmit}
        formData={formData}
        setFormData={setFormData}
      />
    </div>
  );
};

export default AdminUsers;
